import { render, staticRenderFns } from "./ModalCnaeAdicionar.vue?vue&type=template&id=3173e0d3&scoped=true"
import script from "./ModalCnaeAdicionar.vue?vue&type=script&lang=js"
export * from "./ModalCnaeAdicionar.vue?vue&type=script&lang=js"
import style0 from "./ModalCnaeAdicionar.vue?vue&type=style&index=0&id=3173e0d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3173e0d3",
  null
  
)

export default component.exports